import Button from "@web-ui/components/Button";
import Skeleton from "@web-ui/components/Skeleton";
import type { ContentReport } from "../api";
import { NoData } from "../components/no-data";
import { TopContent } from "../components/top-content";
import type { ItemRef } from "../item-names";
import type { Report } from "../use-report";

const SHOWN = 5;

/** Top content: the five most played of the period, each linking to its page, and the way to Analytics › Content. */
export function TopContentCard({ report, nameOf, noun, contentHref }: { report: Report<ContentReport>; nameOf: (id: string) => ItemRef; /** The business's plural ("Classes"). */ noun: string; contentHref: string }) {
  const rows = report.data?.items ?? null;
  return (
    <section className={`card flex flex-col gap-3 transition-opacity ${report.stale ? "opacity-60" : ""}`} aria-labelledby="top-content" aria-busy={(!rows && !report.failed) || report.stale || undefined}>
      <div className="flex items-center gap-3">
        <div className="me-auto min-w-0 ps-card-inset py-1">
          <h2 id="top-content" className="text-sub-title-1">Most played {noun.toLowerCase()}</h2>
          <p className="text-body-2 text-t-secondary">The {SHOWN} with the most plays in this period.</p>
        </div>
        <Button as="a" variant="ghost" size="sm" href={contentHref}>See all</Button>
      </div>
      {!rows ? (report.failed ? <p className="text-body-2 text-t-secondary ps-card-inset pb-2">Not available right now.</p> : <div className="px-card-inset pb-2"><Skeleton lines={SHOWN + 2} /></div>)
        : rows.length === 0 ? <NoData title="Nothing played yet" />
        : <TopContent rows={rows} nameOf={nameOf} limit={SHOWN} />}
    </section>
  );
}
